if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variantId = event.data.variant.id;

    document.querySelectorAll("[data-cl-variant-files-row]").forEach((row) => {
      const productUrl = row.dataset.productUrl;
      const sectionId = row.dataset.sectionId;

      fetch(`${productUrl}?variant=${variantId}&section_id=${sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          const updated = html.getElementById(row.id);
          if (updated) row.outerHTML = updated.outerHTML;
        })
        .catch((e) => console.error(e));
    });
  });
}
